// Centralised media URLs (stock + AI-generated overlays) + ES copy
// Brand: My Valhalla — Celebra tu Legado (mivalhalla.com)
export const ASSETS = {
  logo: "/logo-myvalhalla.png",
  vikingShip: "/generated/hero_bg.jpg",
  vikingShipAI: "/generated/viking_ship_fog.png",
  valhallaGates: "/generated/valhalla_gates_new.jpg",
  valhallaGatesAI: "/generated/valhalla_gates_closed.png",
  valhallaOpenAI: "/generated/valhalla_gates_opening.png",
  valhallaParadise: "/generated/valhalla_paradise.jpg",
  auroraFinale: "/generated/aurora_legacy_bg.jpg",
  auroraFinaleAI: "/generated/aurora_legacy.png",

  // "Álbum de Vida" — life album moments
  memories: [
    { src: "/generated/memory_0.jpg", caption: "Niños jugando", year: "1962" },
    { src: "/generated/memory_1.jpg", caption: "El primer nieto", year: "1985" },
    { src: "/generated/memory_2.jpg", caption: "Toda la familia", year: "1991" },
    { src: "/generated/memory_3.jpg", caption: "Verano en el mar", year: "1974" },
    { src: "/generated/memory_4.jpg", caption: "Nuestra boda", year: "1968" },
    { src: "/generated/memory_5.jpg", caption: "Padre e hijo", year: "1971" },
  ],

  // "Cápsulas de Tiempo Digitales" — messages programmed for the future
  storytellers: [
    {
      poster: "/generated/story_0.jpg",
      title: "Para el día de tu boda",
      duration: "04:12",
      excerpt: "Cuando leas esto ya estarás casándote. Quería que mis palabras llegasen primero…",
    },
    {
      poster: "/generated/story_1.jpg",
      title: "Lo que aprendí de mi padre",
      duration: "06:48",
      excerpt: "No hay vergüenza en dar la vuelta. Solo en no haber zarpado nunca.",
    },
    {
      poster: "/generated/story_2.jpg",
      title: "Para mis nietos, cuando crezcan",
      duration: "03:30",
      excerpt: "Lleváis más de mí que mi apellido. Llevadlo con bondad.",
    },
    {
      poster: "/generated/story_3.jpg",
      title: "Lo que la gratitud me enseñó",
      duration: "05:20",
      excerpt: "No fui dueño de los años — solo fui su invitado.",
    },
  ],

  sampleVideo: "https://cdn.coverr.co/videos/coverr-old-man-walking-in-the-forest-3331/1080p.mp4",
};

// Hitos del legado: del nacimiento al "viaje final"
export const TIMELINE = [
  { id: "birth", year: "1944", title: "Nacimiento", body: "Donde empieza una historia que merece ser contada." },
  { id: "youth", year: "1962", title: "Juventud", body: "Las primeras canciones, las primeras decisiones que marcan." },
  { id: "marriage", year: "1968", title: "Encuentro", body: "La persona que cambió el rumbo del viaje." },
  { id: "children", year: "1972", title: "Hijos", body: "El legado más vivo: las personas que se quedan." },
  { id: "grandchildren", year: "1996", title: "Nietos", body: "Pequeñas voces que reciben las palabras que nunca se dijeron en vida." },
  { id: "achievements", year: "2008", title: "Lo Construido", body: "Una casa, un nombre, un sentido que merece quedarse." },
  { id: "final", year: "·", title: "El Viaje Final", body: "No el adiós. La entrega del legado a quienes amamos." },
];

export const COPY = {
  brand: "My Valhalla",
  brandTagline: "Celebra tu Legado",
  brandShort: "MV",
  domain: "mivalhalla.com",

  navLinks: [
    { href: "#scene-arrival", label: "El Viaje" },
    { href: "#scene-gates", label: "Tu Valhalla" },
    { href: "#scene-memories", label: "Álbum de Vida" },
    { href: "#scene-stories", label: "Cápsulas" },
    { href: "#scene-timeline", label: "Legado" },
  ],
  scrollHint: "Desplázate para descubrir",
  intro: "Celebra tu Legado",
  ctaPrimary: "Únete a la lista de espera",
  ctaSecondary: "Cómo funciona",

  scenes: {
    arrival: {
      label: "My Valhalla · Capítulo I",
    },
    gates: {
      label: "My Valhalla · Capítulo II",
      heading: ["Las Puertas de tu propio", "Valhalla"],
    },
    transition: {
      quote: "No se trata de morir. Se trata de que te recuerden de una manera especial y eterna.",
    },
    memories: {
      label: "Funcionalidad · Álbum de Vida",
      heading: ["Una vida hecha de", "momentos"],
      body: "Sube fotos y vídeos organizados por etapas de tu vida, con narraciones de voz o texto adjuntas. Tu álbum se convierte en un libro de memorias para los tuyos.",
    },
    stories: {
      label: "Funcionalidad · Cápsulas de Tiempo Digitales",
      heading: ["Tus palabras, en el", "momento exacto"],
      body: "Mensajes de texto, audio y vídeo que se entregan en fechas que tú eliges — la graduación de tu hijo, la boda de tu nieta, un cumpleaños — incluso cuando ya no estés para decirlas.",
      tag: "Cápsula",
    },
    timeline: {
      label: "My Valhalla · Capítulo VI",
      heading: ["Tu legado, en", "siete actos"],
    },
    finale: {
      label: "My Valhalla · Capítulo Final",
      dedication: "Celebra tu Legado",
      dates: "mivalhalla.com",
    },
  },

  footer: {
    main: "My Valhalla · Celebra tu Legado · mivalhalla.com",
    quote: "“Recuerda: No se trata de morir. Se trata de que recuerden lo mejor de ti.”",
  },
  storyMute: { on: "Silenciar", off: "Activar sonido" },
};
